import {
  EmailReportUserCreateRequest,
  EmailReportUserInputs,
  EmailReportUserUpdateRequest,
} from '../../../types/app/emailReportUser.types';

export const convertDataFromInputToCreateRequest = (
  data: EmailReportUserInputs,
): EmailReportUserCreateRequest => ({
  id: data.id,
  userId: data.userId.id,
  emailReportId: data.emailReportId,
});

export const convertDataFromInputToUpdateRequest = (
  data: EmailReportUserInputs,
): EmailReportUserUpdateRequest => ({
  id: data.id,
  userId: data.userId.id,
  emailReportId: data.emailReportId,
});
